import {MenuItem, Select} from "@mui/material";


export default function ({onChange, defaultValue}) {
    return (
        <Select variant={"standard"} defaultValue={defaultValue} onChange={onChange} fullWidth data-test="select-vat">
            <MenuItem value={0}>0 %</MenuItem>
            <MenuItem value={10}>10 %</MenuItem>
            <MenuItem value={20}>20 %</MenuItem>
        </Select>
    );
}